import React from "react";
import { Bounce, toast } from "react-toastify";

const Card = ({ post, isConnected, showModal }) => {
    const showToast = (type, message, onClose = () => {}) => {
        toast[type](message, {
            position: "top-right",
            style: {
                margin: "30px 0 0 0",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "26px",
                color: "#fff",
            },
            autoClose: 1000,
            onClose: onClose,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
        });
    };

    const handleAddonAction = (addon) => {
        if (!addon.slug) return;

        if( addon.status == 'buyable' ) {
            window.open(addon.url, "_blank");
            return;
        }

        easycommerce_modal(true);

        fetch(`${EASYCOMMERCE.rest_base}/connectivity/addons`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
            body: JSON.stringify({ action: ( addon.status === "active" ? "deactivate" : "activate" ), addon: addon.slug }),
        })
            .then((res) => res.json())
            .then((data) => {
                easycommerce_modal(false);
                if (data.success && data.data.status) {
                    showToast("success", data.data.message, () =>
                        window.location.reload()
                    );
                } else {
                    showToast("error", data.data.message);
                }
            });
    };

    return (
        <div className="flex flex-col border border-ec-border rounded-lg">
            <a href={post.url} target="_blank">
                <img
                    className="w-full h-auto rounded-t-lg"
                    src={post.thumbnail}
                    alt=""
                />
            </a>
            <div className="p-4 h-full flex flex-col justify-between">
                <div>
                    <a className="block mb-2" href="#">
                        <h2 className="text-ec-body text-xl leading-[32px] font-medium font-inter">
                            {post.name.slice(0, 30)}
                        </h2>
                    </a>
                    <p className="text-ec-body font-inter text-sm leading-[24px] mb-3">
                        {post.desc}
                    </p>
                </div>
                <div className="flex items-center justify-between">
                    <a
                        className="text-base leading-[26px] text-ec-primary font-inter font-normal 
                        hover:text-ec-primary focus:text-ec-primary focus:shadow-none focus:outline-none 
                        active:text-ec-primary"
                        target="_blank"
                        href={post.url}
                    >
                        Learn More
                    </a>

                    <button
                        className={`py-2 px-4 border border-ec-primary rounded-md text-base 
                        font-inter font-normal transition-all duration-300 ${
                            post.status === "active"
                                ? "hover:bg-ec-primary text-ec-primary hover:text-white"
                                : "bg-ec-primary text-white"
                        }`}
                        onClick={
                            isConnected
                                ? () =>
                                      handleAddonAction(post)
                                : () => showModal()
                        }
                    >
                        {post.action_text}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Card;
